/* unplugin-vue-components disabled */"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-7314052a"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "machine-item-wrap" };
const _hoisted_2 = _withScopeId(() => (0, vue_2.createElementVNode)("div", { style: { "flex": "1" } }, null, -1));
const model_1 = require("@/model");
const SensitiveInput_1 = tslib_1.__importDefault(require("@/components/SensitiveInput"));
const DeleteBtn_1 = tslib_1.__importDefault(require("@/components/DeleteBtn"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'MachineItem',
    props: {
        machine: {
            type: model_1.Machine,
            required: true
        },
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        isShowDelBtn: {
            type: Boolean,
            default: true,
        }
    },
    emits: ['delConfirm'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        function onClickDel() {
            emit('delConfirm');
        }
        function onZAngleChangeCallback(index, val, key) {
            props.machine.pr[key.toLowerCase()] = val;
        }
        return (_ctx, _cache) => {
            const _component_el_text = (0, vue_2.resolveComponent)("el-text");
            const _component_el_button = (0, vue_2.resolveComponent)("el-button");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createVNode)((0, vue_2.unref)(SensitiveInput_1.default), {
                    model: __props.machine.name,
                    "onUpdate:model": _cache[0] || (_cache[0] = ($event) => ((__props.machine.name) = $event)),
                    style: { "width": "120px" },
                    disabled: __props.isReadOnly,
                    maxlength: 15
                }, null, 8, ["model", "disabled"]),
                (0, vue_2.createVNode)(_component_el_text, { type: "info" }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(__props.machine.type == (0, vue_2.unref)(model_1.ENTITY_TYPE).ROBOT ? `${__props.machine.model.name} ${__props.machine.model.brand}` : ''), 1)
                    ]),
                    _: 1
                }),
                _hoisted_2,
                (__props.isShowDelBtn)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(DeleteBtn_1.default), {
                        key: 0,
                        title: `确定删除'${__props.machine.name}'吗？`,
                        onDelConfirm: onClickDel
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)(_component_el_button, {
                                disabled: __props.isReadOnly,
                                style: { "width": "30px", "max-width": "50px", "flex": "auto" }
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createTextVNode)("删除")
                                ]),
                                _: 1
                            }, 8, ["disabled"])
                        ]),
                        _: 1
                    }, 8, ["title"]))
                    : (0, vue_2.createCommentVNode)("", true)
            ]));
        };
    }
});
